/* eslint-disable max-len */
/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Switch from 'react-ios-switch';
import InputMask from 'react-input-mask';
import HeaderComponent from '../components/table/header/headerComponent';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

const styles = {
  readOnlyLight: { backgroundColor: '#fff', background: '#fff', opacity: 1 },
};

class RegisterMonitorDetails extends React.PureComponent {
  findComboName = (id, type = '') => {
    try {
      const { contact } = this.props.settings;
      let value = '';
      if (!contact) return '';

      if (type === 'business' && contact.business) {
        value = contact.business.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      if (type === 'roles' && contact.roles) {
        value = contact.roles.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      if (type === 'sectors' && contact.sectors) {
        value = contact.sectors.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      return '';
    } catch (e) {
      return '';
    }
  }

  renderCnpj = item => (
    <React.Fragment>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="email" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.email || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="cnpj" /></p>
        <InputMask
          readOnly
          mask="99.999.999/9999-99"
          value={item.cnpj || ''}
        >
          {inputProps => (
            <input
              {...inputProps}
              readOnly
              type="text"
              className="form-control"
              style={{ ...styles.readOnlyLight, marginTop: '10px' }}
            />
          )}
        </InputMask>
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="cep" /></p>
        <InputMask
          readOnly
          mask="99.999-999"
          value={item.cep || ''}
        >
          {inputProps => (
            <input
              {...inputProps}
              readOnly
              type="text"
              className="form-control"
              style={{ ...styles.readOnlyLight, marginTop: '10px' }}
            />
          )}
        </InputMask>
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="address" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.address || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="number" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.number || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="complement" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.complement || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="district" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.district || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="city" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.city || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="state" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.state || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="country" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.country || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="name" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.firstName || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="lastName" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.lastName || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="phone" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.phone || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="role" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={this.findComboName(item.role, 'roles')}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="sector" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={this.findComboName(item.sector, 'sectors')}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="company" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.companyName || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="stateRegistration" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.stateRegistration || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="purpose" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.purpose || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="business" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={this.findComboName(item.business, 'business')}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="naoContribIcms" /></p>
        <Switch
          checked={item.naoContribIcms}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="icmsIsento" /></p>
        <Switch
          checked={item.icmsIsento}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="icmsDiferido" /></p>
        <Switch
          checked={item.icmsDiferido}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="pisCofins" /></p>
        <Switch
          checked={item.pisCofins}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="ipi" /></p>
        <Switch
          checked={item.ipi}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="proEmprego" /></p>
        <Switch
          checked={item.proEmprego}
          className="margin-bottom-2"
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="clientId" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.codEmitente || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="contractId" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.idContato || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="registerDate" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.createdAt || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="registerUpdated" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.updatedAt || ''}
        />
      </div>
    </React.Fragment>
  )

  renderCpf = item => (
    <React.Fragment>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="email" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.email || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="cpf" /></p>
        <InputMask
          readOnly
          mask="999.999.999-99"
          value={item.cnpj || ''}
        >
          {inputProps => (
            <input
              {...inputProps}
              readOnly
              type="text"
              className="form-control"
              style={{ ...styles.readOnlyLight, marginTop: '10px' }}
            />
          )}
        </InputMask>
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="cep" /></p>
        <InputMask
          readOnly
          mask="99.999-999"
          value={item.cep || ''}
        >
          {inputProps => (
            <input
              {...inputProps}
              readOnly
              type="text"
              className="form-control"
              style={{ ...styles.readOnlyLight, marginTop: '10px' }}
            />
          )}
        </InputMask>
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="address" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.address || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="number" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.number || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="complement" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.complement || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="district" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.district || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="city" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.city || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="state" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.state || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="country" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.country || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="name" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.firstName || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="lastName" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.lastName || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="phone" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.phone || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="clientId" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.codEmitente || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="contractId" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.idContato || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="registerDate" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.createdAt || ''}
        />
      </div>
      <div className="form-group">
        <p className="margin-bottom-2"><Translate value="registerUpdated" /></p>
        <input
          readOnly
          type="text"
          className="form-control"
          placeholder=""
          style={styles.readOnlyLight}
          value={item.updatedAt || ''}
        />
      </div>
    </React.Fragment>
  )

  goBack = () => {
    history.push({ pathname: ROUTES.REGISTER_MONITOR });
  }

  render() {
    const { location } = this.props;
    if (!(location && location.item)) return null;

    const { item } = location;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent
            title={I18n.t('details')}
          />
          <div className="margin-top-20 ">
            {item.typeDoc && item.typeDoc === 'cnpj' ? this.renderCnpj(item) : this.renderCpf(item)}
            <div className="row margin-left-0">
              <button
                type="button"
                onClick={this.goBack}
                className="btn btn-warning margin-right-15"
              >
                <Translate value="return" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterMonitorDetails);
